module.exports = __webpack_public_path__ + "media/fr_ca_s1_Allese.cab9a5b4.mp3";